import { trpc } from "../trpc";

/**
 * List folders in a different account the current user belongs to. Used by
 * the Folder Picker Modal in the cross-account copy flow to show destination
 * options. Returns a flat list with `parentId` / `rootId` so callers can
 * reconstruct the tree client-side.
 *
 * `targetAccountId` may be `undefined` while the user hasn't picked a target
 * workspace yet — in that case the query is disabled.
 */
export function useListFoldersForTargetAccount(
  targetAccountId: string | undefined,
) {
  const query = trpc.folder.listFoldersForTargetAccount.useQuery(
    { targetAccountId: targetAccountId ?? "" },
    { enabled: !!targetAccountId },
  );

  return {
    folders: query.data?.results ?? [],
    count: query.data?.count ?? 0,
    resolvedAccountId: query.data?.resolvedAccountId,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
